import { SnowplowService } from "~/services/public/Snowplow"
import { getv4LocaleFromI18nLocale } from "~/scripts/useful-functions"
import { newTracker } from "@snowplow/browser-tracker"
import { enableLinkClickTracking } from '@snowplow/browser-plugin-link-click-tracking';

export default defineNuxtPlugin(nuxtApp => {
  if (import.meta.client) {
    newTracker("cms-content-tracker", nuxtApp.$config.public.snowplowHost, {
      appId: "cms-content",
      platform: "web",
      discoverRootDomain: true,

      crossDomainLinker: function (linkElement) {
        const href = linkElement.href;

        if (!href) return false;

        const isAnyVan = href.indexOf('anyvan.') > -1;

        const currentHost = window.location.hostname;
        const isDifferentDomain = href.indexOf(currentHost) === -1;

        // Only decorate the link if it's AnyVan AND it's a different domain
        return isAnyVan && isDifferentDomain;
      }
    })

    enableLinkClickTracking({
      pseudoClicks: true,
      trackContent: true
    });

    const snowplowService = new SnowplowService()
    const locale = getv4LocaleFromI18nLocale(nuxtApp.$i18n.locale.value)
    snowplowService.addLocaleContext(locale)

    return {
      provide: {
        snowplow: snowplowService
      }
    }
  }
})
